import type { GcsConfig } from '../../types/gcs/gcsConfig';
import { createLogger } from '../../utils/logger';

const logger = createLogger('GcsConfigs');

const parseGcsConfigs = (): readonly GcsConfig[] => {
  const envValue = import.meta.env.VITE_GCS_CONFIGS;
  if (!envValue) {
    logger.warn('VITE_GCS_CONFIGS environment variable is not set');
    return [];
  }
  try {
    return JSON.parse(envValue) as GcsConfig[];
  } catch (error) {
    logger.error('Failed to parse VITE_GCS_CONFIGS:', error);
    return [];
  }
};

export const GCS_CONFIGS: readonly GcsConfig[] = parseGcsConfigs();

export const getServerNameCode = (gcsId: string): string =>
  GCS_CONFIGS.find((config) => config.id === gcsId)?.nameCode ?? gcsId;

export const getServerName = (gcsId: string): string =>
  GCS_CONFIGS.find((config) => config.id === gcsId)?.name ?? gcsId;
